"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var children_1 = require("../utils/children");
var defaultModuleState = {
    currentTopic: "",
    currentInteraction: "",
    topics: [],
    interactions: [],
    history: []
};
exports.ModuleContext = react_1.createContext([
    defaultModuleState,
    function () { }
]);
exports.ModuleReducer = function (state, action) {
    if (state === void 0) { state = defaultModuleState; }
    switch (action.type) {
        case "GOTO":
            var history_1 = state.history.splice(0);
            history_1.push(action.data);
            return __assign(__assign({}, state), { currentTopic: action.data });
        case "GO_FORWARD":
            var histf = state.history.splice(0);
            histf.push(action.data);
            var _a = action.data.split(":"), to_1 = _a[0], ti = _a[1];
            var topic = state.topics.find(function (t) { return t.name === to_1; });
            if (!topic) {
                return state;
            }
            var int = topic.interactions.indexOf(ti);
            if (int === -1) {
                return state;
            }
            if (int === topic.interactions.length - 1) {
                var topicID = state.topics.findIndex(function (t) { return t.name === to_1; });
                if (topicID === -1) {
                    return state;
                }
                if (topicID === state.topics.length - 1) {
                    return state;
                }
                var currentInteraction = state.topics[topicID + 1].interactions[0];
                return __assign(__assign({}, state), { currentTopic: state.topics[topicID + 1].name, currentInteraction: currentInteraction, history: histf });
            }
            else {
                var currentInteraction = topic.interactions[int + 1];
                return __assign(__assign({}, state), { currentTopic: to_1, currentInteraction: currentInteraction, history: histf });
            }
        case "GO_BACK":
            var histb = state.history.splice(0);
            var prev = histb.pop();
            console.log(prev);
            if (!prev)
                return state;
            var _b = prev.split(":"), top_1 = _b[0], inter = _b[1];
            console.log(inter);
            return __assign(__assign({}, state), { currentTopic: top_1, currentInteraction: inter, history: histb });
    }
    return state;
};
exports.goToPath = function (p) {
    return {
        type: "GO_TO",
        data: p
    };
};
exports.goBack = function () {
    return {
        type: "GO_BACK"
    };
};
exports.goForward = function (current) {
    return {
        type: "GO_FORWARD",
        data: current
    };
};
exports.Module = function (_a) {
    var children = _a.children;
    react_1.useMemo(function () {
        var topics = children_1.Select(children, "Topic");
        defaultModuleState.currentTopic = topics[0].props.name;
        topics.forEach(function (child, i) {
            var topic = {
                name: child.props.name,
                interactions: []
            };
            defaultModuleState.topics.push(topic);
            var interactions = children_1.Select(child.props.children, "Interaction");
            interactions.forEach(function (int, j) {
                defaultModuleState.interactions.push(int.props.name);
                topic.interactions.push(int.props.name);
            });
        });
        defaultModuleState.currentInteraction =
            defaultModuleState.topics[0].interactions[0];
    }, [children]);
    var _b = react_1.useReducer(exports.ModuleReducer, defaultModuleState), state = _b[0], dispatch = _b[1];
    return (react_1.default.createElement(exports.ModuleContext.Provider, { value: [state, dispatch] },
        react_1.default.createElement(react_1.default.Fragment, null,
            children[0],
            react_1.cloneElement(children[1], { active: state.currentTopic }))));
};
exports.Module.displayName = "Module";
